module.exports = __webpack_public_path__ + "static/media/settings-orange.f5665471.svg";